var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-rating',{attrs:{"color":_vm.$store.state.mainColor,"length":_vm.len,"readonly":"","empty-icon":"mdi-circle-outline","full-icon":"mdi-circle","half-icon":"mdi-circle-half-full"},model:{value:(_vm.rating),callback:function ($$v) {_vm.rating=$$v},expression:"rating"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }